<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-groups"></em> Groups</h1>
			</div>
			<div class="col-12 col-md-6 col-lg-4 text-right">
				<router-link to="/group/0" class="btn btn-primary"><em class="fas fa-user-tag"></em> Add Group</router-link>
			</div>
		</div>

		<div class="list-group">
			<router-link :to="'group/' + g.group_id" v-for="g in groups" :key="g.group_id" class="list-group-item list-group-item-action">
				<div class="row">
					<div class="col-12 col-md-6">{{g.group_name}}</div>
					<div class="col-12 col-md-6">Schools: {{g.schools}}<br>Operators: {{g.operators}}</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
export default
{
	name: 'Groups',
	props: ["current_user"],
	data: function()
	{
		return {
			groups: [],
			loading: true,
		}
	},
	mounted: function()
	{
		this.loadGroups();
	},
	methods:
	{
		loadGroups: function()
		{
			var vm = this;
			vm.loading = true;
			vm.startLoading();

			this.CORS("GET", "/groups", null,
			function(response)
			{
				vm.groups = response;
				vm.loading = false;
				vm.stopLoading();
			}, function(response)
			{
				vm.showError("Error Loading Groups", response.responseText, true, null);
				vm.loading = false;
				vm.stopLoading();
			})
		}
	},
	watch: {
		'current_user' ()
		{
			if(this.current_user.user_id == null)
			{
				return;
			}

			if (!this.userHasAction(this.current_user, ['ADMIN']))
			{
				this.$router.push("/").catch(function() { /* ignore error */ });
			}
		}
	}
}
</script>
